export const METRICS_CUSTOM_COLUMN = 'reports-customcolumn_'
export const METRICS_CUSTOM_EVENT = 'reports-customevent_'
export const METRICS_CUSTOM_EVENT_REVENUE = 'reports-customeventrevenue_'
export const METRICS_CUSTOM_EVENT_HIDDEN_REVENUE = 'reports-customeventhiddenrevenue_'
export const CAMPAIGNS_EXTERNAL_STATUS_PROPELLER  = 'campaigns_external_status_propeller'
export const YES_NO  = 'yes_no'
export const POSTBACK_SENT_FAILED  = 'postback_sent_failed'
export const REPORTS_COST  = 'reports_cost'
export const COLUMN_WITH_INTEGRATION  = 'column-with-integration'
export const SUSPICIOUS_EVENT  = 'suspicious-event'

export const GENERAL_PRESET  = 'general'
